import type { Cita } from './api/tipos.js';

/**
 * Reparte las citas en próximas y anteriores, cada grupo en su orden útil.
 *
 * La API las devuelve de la más reciente a la más antigua, que es el orden
 * correcto para el histórico pero el contrario del que hace falta arriba: en
 * «Próximas», lo que el cliente quiere ver primero es **la siguiente**, no la
 * que tiene dentro de tres semanas.
 *
 * Una cita cuenta como próxima hasta que **termina**, no hasta que empieza: a
 * las 09:05 de una cita de 09:00 a 09:10 sigue siendo la de ahora mismo, y
 * mandarla al histórico sería desconcertante.
 */
export function separarCitas(
  citas: Cita[],
  ahora: number = Date.now(),
): { proximas: Cita[]; pasadas: Cita[] } {
  const proximas: Cita[] = [];
  const pasadas: Cita[] = [];

  for (const cita of citas) {
    const fin = new Date(cita.inicio).getTime() + cita.duracionMin * 60_000;
    if (fin > ahora) proximas.push(cita);
    else pasadas.push(cita);
  }

  return {
    // La siguiente, primero.
    proximas: proximas.sort((a, b) => enMilisegundos(a) - enMilisegundos(b)),
    // La más reciente, primero.
    pasadas: pasadas.sort((a, b) => enMilisegundos(b) - enMilisegundos(a)),
  };
}

function enMilisegundos(cita: Cita): number {
  return new Date(cita.inicio).getTime();
}
